import React from 'react'
import RestaurantHero from './RestaurantPages/RestaurantHero'
import InfoSection from './InfoSection'
import CustomerResultsSection from './CustomerResultsSection'
import RestaurantFeatures from './RestaurantPages/RestaurantFeatures'
import Hero from './HomePage/components/Hero'

function RestaurantPage() {
  return (
    <div>
      <RestaurantHero />
      <Hero />
      <InfoSection />
      <CustomerResultsSection />
      <RestaurantFeatures />
    </div>
  )
}

export default RestaurantPage